/* section-hp-unboxing.js (7 Oct 2026) — the contents rail of „DAS IST DRIN." (sections/hp-unboxing.liquid).
   Playback is the reels engine (section-reels-grid.js); this file only follows the film. While it really plays
   (the engine's .is-video on the media), the section gets .is-synced and each [data-unbox-item] gets is-on (its cue
   window data-in … data-out, in seconds, is running; --p = how far), is-done (shown already in this loop) or
   neither. requestAnimationFrame runs only while the film plays. Whenever the film is not playing — paused because
   it is under 60 % on screen or the tab is hidden (QA 7 Oct: a frozen half-filled rail read as a stuck progress
   bar), or back on the still (stall, watchdog, reduced motion, Save-Data, a dead source) — the rail is a static
   legend; 'playing' syncs it again.
   Never touches playback, never publishes events. */
(function () {
  'use strict';

  function init(root) {
    if (root.__unbox) return;
    root.__unbox = true;
    var media = root.querySelector('[data-reels-media]');
    var video = root.querySelector('[data-reels-video]');
    var rows = [].slice.call(root.querySelectorAll('[data-unbox-item]'));
    if (!media || !video || !rows.length) return;

    var cues = rows.map(function (el) {
      return { el: el, a: parseFloat(el.getAttribute('data-in')) || 0, b: parseFloat(el.getAttribute('data-out')) || 0 };
    });
    var raf = 0;

    function end(i) {
      var c = cues[i];
      if (c.b > c.a) return c.b;
      if (cues[i + 1]) return cues[i + 1].a;
      return isFinite(video.duration) && video.duration > c.a ? video.duration : c.a + 1;
    }

    function stop() {
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
    }

    function unsync() {
      stop();
      root.classList.remove('is-synced');
      cues.forEach(function (c) {
        c.el.classList.remove('is-on', 'is-done');
        c.el.style.removeProperty('--p');
      });
    }

    function paint() {
      raf = 0;
      if (!video.isConnected || !media.classList.contains('is-video')) { unsync(); return; }
      root.classList.add('is-synced');
      var t = video.currentTime;
      cues.forEach(function (c, i) {
        var b = end(i);
        var on = t >= c.a && t < b;
        var done = t >= b;
        c.el.classList.toggle('is-on', on);
        c.el.classList.toggle('is-done', done);
        c.el.style.setProperty('--p', on ? Math.min(1, (t - c.a) / (b - c.a)).toFixed(3) : (done ? '1' : '0'));
      });
      if (!video.paused && !video.ended) raf = requestAnimationFrame(paint);
    }

    video.addEventListener('playing', function () { if (!raf) raf = requestAnimationFrame(paint); });
    video.addEventListener('pause', unsync);
    // The engine hides the film (stall) or removes it for good (kill): follow its class on the media.
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        if (!media.classList.contains('is-video')) unsync();
        else if (!video.paused && !raf) raf = requestAnimationFrame(paint);
      }).observe(media, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function boot(scope) {
    [].slice.call(scope.querySelectorAll('[data-hp-unbox]')).forEach(init);
  }
  boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
